module.exports = __webpack_public_path__ + "img/arrow_right_s.fd34c714.svg";